
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.361 0a1.556 1.556 0 00-1.536 1.3l.987.164-.987-.164-1.341 8.05-3.081-2.465a1 1 0 00-1.625.781v2.364l-3.93-3.145a1 1 0 00-1.625.781V20H1a1 1 0 100 2h20a1 1 0 100-2h-1.222v-7.889a.993.993 0 00-.013-.162L18.172 1.325l-.989.148.989-.148A1.555 1.555 0 0016.632 0v1-1h-1.27l-.001 1V0zm.833 1.622L14.354.368l1.84 1.254zM16.25 2h.382a.444.444 0 01-.44-.378l.058.378zm-.515 0l-1.463 8.781.412.33h2.932L16.251 2h-.515zm0 0l.062-.371a.444.444 0 01-.437.371h.375zm2.042 11.11V20H4.223V9.747l3.93 3.144a1 1 0 001.625-.78V9.747l3.931 3.144a1 1 0 00.625.22h3.444zM6.666 16.556a1 1 0 011-1h1.111a1 1 0 110 2H7.666a1 1 0 01-1-1zm6.557-1a1 1 0 100 2h1.11a1 1 0 000-2h-1.11z","fill":"#0C1D59"}})])
          )
        }
      }
    